import React from 'react';
import useLanguageLinks from '../navigation/useLanguageLinks';
import LangA from '../../i18n/LangA';
import CloudflareImage from '../cloudflare-image/CloudflareImage';

const LanguageMenu = () => {
  const languageLinks = useLanguageLinks();

  return (
    <ul>
      {languageLinks.map((ll) => {
        if (ll.isCurrent) {
          return (
            <li className="ie11-link-lg" key={ll.lang}>
              <CloudflareImage
                id={'navigation_' + ll.lang + '_button'}
                src={ll.flag}
                alt={ll.languageName}
                className="country-flag"
                loading="lazy"
                decoding="async"
                width="20"
                height="17"
              />
              <strong id={'navigation_' + ll.lang + '_text'} style={{ color: 'black' }}>
                {ll.languageName}
              </strong>
            </li>
          );
        } else {
          return (
            <li className="ie11-link-lg" key={ll.lang}>
              <LangA id={'navigation_' + ll.lang + '_text'} href={ll.path} title={ll.languageName}>
                <CloudflareImage
                  id={'navigation_' + ll.lang + '_button'}
                  src={ll.flag}
                  alt={ll.languageName}
                  className="country-flag"
                  loading="lazy"
                  decoding="async"
                  width="20"
                  height="17"
                />
                {ll.languageName}
              </LangA>
            </li>
          );
        }
      })}
    </ul>
  );
};

export default LanguageMenu;
